/**
 * The command-palette shortcut as the lawyer's keyboard spells it. The
 * palette already accepts ⌘ and Ctrl (CommandPalette: metaKey || ctrlKey);
 * only the hint said "Ctrl+K" to Mac users (QA Q54). One helper so every
 * hint agrees.
 */
export function isApplePlatform(nav: Navigator | undefined = typeof navigator !== 'undefined' ? navigator : undefined): boolean {
  if (!nav) return false;
  const uaData = (nav as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const platform = uaData?.platform || nav.platform || '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

export function paletteShortcutLabel(nav?: Navigator): string {
  return isApplePlatform(nav) ? '⌘K' : 'Ctrl+K';
}
